import React from "react";
import { createRoot } from "react-dom/client";
import ChangeReleaseFilterIsland from "./ChangeReleaseFilterIsland";

const mountNodes = document.querySelectorAll("[data-change-release-filter-island]");

mountNodes.forEach((mountNode) => {
  if (mountNode.getAttribute("data-react-mounted") === "true") {
    return;
  }

  const rawConfig = mountNode.getAttribute("data-config");

  if (!rawConfig) {
    return;
  }

  const config = JSON.parse(rawConfig);

  createRoot(mountNode).render(<ChangeReleaseFilterIsland config={config} />);
  mountNode.setAttribute("data-react-mounted", "true");
});
